var map = {
	"./bg.png": "abc3",
	"./bottom.png": "a7b0",
	"./buy.png": "8e05",
	"./cancel.png": "413e",
	"./delet.png": "3417",
	"./edit.png": "523f",
	"./noData.png": "0334",
	"./noSelect.png": "a539",
	"./ph.png": "1d88",
	"./pho.png": "8e24",
	"./phone.png": "78f8",
	"./place.png": "24e0",
	"./pnone1.png": "438b",
	"./right.png": "1387",
	"./rist.png": "5422",
	"./select.png": "6d4d",
	"./transport.png": "0123",
	"./wait.png": "32d6",
	"./wei.png": "dd75",
	"./weixin.png": "e1d5",
	"./zhi.png": "89b3",
	"./zhifu.png": "264e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6b5";